/** App Roles on the shared IDC portal Entra app (services/tracker-api/src/auth/entra.ts ROLES). */
export const ROLES = {
  analyst: "SoftwareTrackerAnalyst",
  manager: "SoftwareTrackerManager",
  admin: "SoftwareTrackerAdmin",
} as const;

export const isAdmin = (roles: readonly string[]) => roles.includes(ROLES.admin);
export const isManager = (roles: readonly string[]) => roles.includes(ROLES.manager);
/** A manager without Admin: sees their Entra reporting chain only (AIC-124). Admins are unrestricted. */
export const isTeamManager = (roles: readonly string[]) => isManager(roles) && !isAdmin(roles);
export const hasPortalRole = (roles: readonly string[]) => Object.values(ROLES).some((r) => roles.includes(r));

export function roleLabel(roles: readonly string[]): string {
  if (isAdmin(roles)) return "Admin";
  if (isManager(roles)) return "Manager · your team";
  return "Analyst";
}
